import axios from "axios";

export const getWBNBPrice = async () => {
  try {
    const { data } = await axios.get('https://tifi.net/api/prices/BNB');
    console.log(data);
    return data.quote.USD.price;
  } catch (error) {
    console.error('Failed to get WBNB price!', error);
  }
};